// This icon file is generated automatically.
var Mobile2Outlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M4.4 13.99h11.2V2a.6.6 0 00-.6-.6H5a.6.6 0 00-.6.6v11.99zm0 1.4V18c0 .33.27.6.6.6h10a.6.6 0 00.6-.6v-2.61H4.4zM5 0h10a2 2 0 012 2v16a2 2 0 01-2 2H5a2 2 0 01-2-2V2c0-1.1.9-2 2-2zm5 18a1 1 0 110-2 1 1 0 010 2z" } }] }, "name": "mobile2", "theme": "outlined" };
export default Mobile2Outlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/Mobile2Outlined.js
// module id = 3146
// module chunks = 0